import { createApp } from "vue";
import axios from "axios";

import App from "./visualization/App.vue";

import Loader from "./visualization/components/Loader.vue";
import Pointer from "./visualization/components/Pointer.vue";
import Badge from "./visualization/components/Badge.vue";

const app = createApp(App);

app.config.globalProperties.$axios = axios;

app.component("Loader", Loader);
app.component("Pointer", Pointer);
app.component("Badge", Badge);

app.mount("#app");